import { PathEnum } from "core/routes/path.enum";
import { commonInitApp } from "core/store/actions";
import { useAppDispatch, useAppSelector } from "core/store/hooks";
import { commonIsInitSelector } from "core/store/selectors";
import OnBoardingPage from "pages/onBoarding";
import ReopenPage from "pages/reopened";
import WebhookPage from "pages/webhook";
import { useEffect } from "react";
import { HashRouter, Route, Routes } from "react-router-dom";
import ScrollToTop from "./common/components/scroll-top";
import InvitationPage from "./pages/invitation";

function AppRouter() {
	const dispatch = useAppDispatch();

	const isInit = useAppSelector(commonIsInitSelector);

	useEffect(() => {
		dispatch(commonInitApp());
	}, []);

	if (!isInit) return null;

	return (
		<HashRouter>
			<ScrollToTop />
			<Routes>
				<Route path={`${PathEnum.invitation}/*`} element={<InvitationPage />} />

				<Route path={`${PathEnum.onBoarding}/*`} element={<OnBoardingPage />} />

				<Route path={`${PathEnum.webhook}/*`} element={<WebhookPage />} />

				<Route path={`${PathEnum.reopen}/*`} element={<ReopenPage />} />
			</Routes>
		</HashRouter>
	);
}

export default AppRouter;
